module.exports = __webpack_public_path__ + "img/ic_32_sport_tischtennis.97f576ee.svg";